module.exports = __webpack_public_path__ + "img/pdf.aa2f6581.svg";